/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const SettingForecastPage = lazyLoad(
  () => import('./index'),
  module => module.SettingForecastPage
);
